import { render, staticRenderFns } from "./MenuNewCopy.vue?vue&type=template&id=61ffb3d0&scoped=true&"
import script from "./MenuNewCopy.vue?vue&type=script&lang=js&"
export * from "./MenuNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./MenuNewCopy.vue?vue&type=style&index=0&id=61ffb3d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ffb3d0",
  null
  
)

export default component.exports